import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Artigos = () => {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        axios
            .get(`${API}/articles`)
            .then((r) => setArticles(r.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="page-articles">
            <SEO
                title="Artigos"
                description="Blog jurídico da ACD Advogados. Artigos sobre Direito Imobiliário, Trabalho, Imigração, Empresarial e Patrimonial. Informação jurídica que transforma dúvidas em segurança."
                canonicalPath="/artigos"
            />
            <section className="relative py-20 md:py-28 px-6 bg-[var(--acd-navy-900)] text-white overflow-hidden">
                <div className="absolute inset-0 opacity-25 bg-[url('https://customer-assets.emergentagent.com/job_advogados-staging/artifacts/j7m86eis_pexels-phoze-20738540.webp')] bg-cover bg-center" />
                <div className="absolute inset-0 bg-gradient-to-r from-[var(--acd-navy-950)]/95 to-[var(--acd-navy-900)]/70" />
                <div className="relative z-10 max-w-7xl mx-auto text-center">
                    <span className="acd-eyebrow">Artigos</span>
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mt-3">
                        Informação Jurídica que Transforma Dúvidas em Segurança
                    </h1>
                </div>
            </section>

            <section className="py-20 px-6">
                <div className="max-w-7xl mx-auto">
                    {loading ? (
                        <div className="text-center text-[color:var(--acd-muted)]">
                            A carregar artigos...
                        </div>
                    ) : (
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {articles.map((a) => (
                                <Link
                                    to={`/artigos/${a.slug}`}
                                    key={a.slug}
                                    className="acd-card block"
                                    data-testid={`article-card-${a.slug.substring(0, 25)}`}
                                >
                                    <div
                                        className="w-full h-52 bg-cover bg-center"
                                        style={{
                                            backgroundImage: `url(${a.image})`,
                                        }}
                                    />
                                    <div className="p-6">
                                        <span
                                            className="acd-eyebrow"
                                            style={{
                                                color: "var(--acd-blue-600)",
                                            }}
                                        >
                                            {a.category}
                                        </span>
                                        <h3 className="text-lg font-bold text-[var(--acd-navy-900)] mb-3 leading-snug">
                                            {a.title}
                                        </h3>
                                        <p className="text-sm text-[color:var(--acd-muted)] mb-4 line-clamp-3">
                                            {a.excerpt}
                                        </p>
                                        <span className="inline-flex items-center gap-2 text-sm font-bold text-[var(--acd-blue-600)]">
                                            Ler Mais <ArrowRight size={14} />
                                        </span>
                                        <div className="mt-4 pt-4 border-t border-gray-100 text-xs text-[color:var(--acd-muted)] flex justify-between">
                                            <span>{a.author}</span>
                                            <span>{a.date_display}</span>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Artigos;
